import React from 'react';
import Button from '../../ui/Button';
import { formatFileSize } from './observationFileUtils';

const ObservationFileList = ({ files = [], compact = false, emptyMessage = 'No hay archivos adjuntos.' }) => {
  if (!files.length) {
    if (compact) return null;

    return (
      <div className="approved-requests-page__file-empty">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={`approved-requests-page__file-list${compact ? ' approved-requests-page__file-list--compact' : ''}`}>
      {files.map((file) => {
        const categoryLabel = (file.categories || [])
          .map((category) => category.name || category.alias)
          .filter(Boolean)
          .join(', ');

        return (
          <article
            key={file.id}
            className={`approved-requests-page__file-item${compact ? ' approved-requests-page__file-item--compact' : ''}`}
          >
            <div className="approved-requests-page__file-main">
              <div className="approved-requests-page__file-name" title={file.name || 'Archivo'}>
                {file.name || 'Archivo'}
              </div>
              <div className="approved-requests-page__file-meta">
                <span>{formatFileSize(file.size)}</span>
                {file.created_at && <span>{file.created_at}</span>}
                {categoryLabel && (
                  <span className="approved-requests-page__file-category-inline">{categoryLabel}</span>
                )}
              </div>
              {!compact && (file.categories || []).length > 0 && (
                <div className="approved-requests-page__file-categories">
                  {file.categories.map((category) => (
                    <span key={category.alias || category.id} className="approved-requests-page__file-category">
                      {category.name || category.alias}
                    </span>
                  ))}
                </div>
              )}
            </div>
            {file.url && (
              <Button
                as="a"
                variant={compact ? 'link' : 'outlinePrimary'}
                size="sm"
                className="approved-requests-page__file-view"
                href={file.url}
                target="_blank"
                rel="noreferrer"
              >
                Ver
              </Button>
            )}
          </article>
        );
      })}
    </div>
  );
};

export default ObservationFileList;
